<template>
  <Dialog id="projectDetails-dialog" :modal="true" :closable="false" :visible="true" @hide="close()">
    <template #header>
      <h3>Legg til container</h3>
    </template>

    <containerOrder ref="order" :project="project" />

    <template #footer>
      <Button label="lukk" @click="close()" icon="pi pi-times" class="p-button-text"/>
      <Button label="Largre" icon="pi pi-check" autofocus @click="save()"/>
    </template>
  </Dialog>
</template>

<script>
import containerOrder from '@/components/containers/containerOrder'

import Dialog from 'primevue/dialog';

export default {
name: 'containerOrderModal',

components: {
  Dialog,
  containerOrder,
},

props:{
  project: {
    type: Object
  }
},

methods: {
  close(){
    this.$emit('close')
  },

  save(){
    this.updateDatabase()
    
  },

  updateDatabase(){
    const order = this.$refs.order.getOrder()

    if(order){
      this.$store.dispatch('containerOrders/add', order)
      this.$toast.add({
        severity:'success',
        summary: 'Container er bestilt',
        detail: `Type: ${order.container.size}${order.container.measurementunit} ${order.container.descriptionname}`,
        life: 5000,
      })
      this.$emit('close')
    }

    
    
  },
},

}
</script>